import React, { PropTypes } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import  './CompinedStyle.less';

const Select = ({ input, options, label, meta: { touched, error }, allowEmpty }) => {
   return (<div>
      <FormGroup controlId="formControlsSelect" >
         {label && <ControlLabel>{label}</ControlLabel>}
         <FormControl
            {...input}
            componentClass="select"
            placeholder="select" >
            {allowEmpty === true && <option value="" >{""}</option>}
            {options.map((opt) => (
               <option key={opt.value} value={opt.value} >{opt.label}</option>
            ))}
         </FormControl>
         {touched && error && <span
            className="input-validation-error"
         >{error}</span>}
      </FormGroup>
   </div>);
};

Select.propTypes = {
   input: PropTypes.object,
   meta: PropTypes.object,
   options: PropTypes.array,
   allowEmpty: PropTypes.bool.isRequired,
   label: PropTypes.string.isRequired
};

Select.defaultProps = {
   allowEmpty: false
};

export default Select;



/** WEBPACK FOOTER **
 ** ./src/components/FormTemplate/Select.js
 **/